// extracted by mini-css-extract-plugin
module.exports = {"postionStyle":"styles_postionStyle__qyevH","footer":"styles_footer__1ZnP-"};